var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hm-link"},[_vm._v(" "+_vm._s(_vm.value.cta.desc)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }